var _rect, _rect2, _rect3, _g, _rect4, _rect5, _g2, _rect6, _rect7, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.1558,
    height: 55.1587,
    rx: 7.25149,
    fill: "#C0D8D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 50.8982 17.3848)",
    fill: "url(#paint0_linear_6374_22460)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 50.8982 17.3848)",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.25079,
    cy: 7.25079,
    r: 7.25079,
    transform: "matrix(-1 0 0 1 18.0898 12.958)",
    fill: "url(#paint1_linear_6374_22460)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.25079,
    cy: 7.25079,
    r: 7.25079,
    transform: "matrix(-1 0 0 1 18.0898 12.958)",
    fill: "black",
    fillOpacity: 0.1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 47.1433 31.8975)",
    fill: "url(#paint2_linear_6374_22460)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 47.1433 31.8975)",
    fill: "black",
    fillOpacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.49597,
    cy: 3.49597,
    r: 3.49597,
    transform: "matrix(-1 0 0 1 14.335 31.2246)",
    fill: "url(#paint3_linear_6374_22460)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.49597,
    cy: 3.49597,
    r: 3.49597,
    transform: "matrix(-1 0 0 1 14.335 31.2246)",
    fill: "black",
    fillOpacity: 0.1
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 47.1433 42.6543)",
    fill: "url(#paint4_linear_6374_22460)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 34.153,
    height: 5.64734,
    rx: 1.3446,
    transform: "matrix(-1 0 0 1 47.1433 42.6543)",
    fill: "black",
    fillOpacity: 0.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.49597,
    cy: 3.49597,
    r: 3.49597,
    transform: "matrix(-1 0 0 1 14.335 41.9814)",
    fill: "url(#paint5_linear_6374_22460)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.49597,
    cy: 3.49597,
    r: 3.49597,
    transform: "matrix(-1 0 0 1 14.335 41.9814)",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6374_22460",
    x1: 7.01694,
    y1: 1.58039e-8,
    x2: 8.51613,
    y2: 10.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6374_22460",
    x1: 2.97944,
    y1: 4.05822e-8,
    x2: 16.2197,
    y2: 14.8337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6374_22460",
    x1: 7.01694,
    y1: 1.58039e-8,
    x2: 8.51613,
    y2: 10.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6374_22460",
    x1: 1.43654,
    y1: 1.95667e-8,
    x2: 7.82033,
    y2: 7.15207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6374_22460",
    x1: 7.01694,
    y1: 1.58039e-8,
    x2: 8.51613,
    y2: 10.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6374_22460",
    x1: 1.43654,
    y1: 1.95667e-8,
    x2: 7.82033,
    y2: 7.15207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendation);
export default __webpack_public_path__ + "static/media/recommendation.4f30c0b1eda9a8fed386b332c592a819.svg";
export { ForwardRef as ReactComponent };